export default __webpack_public_path__ + "static/media/tituloEN.884fe57c.png";